export const getExhibitorsV2Translations = (intl) => ({
  Filters: {
    searchBar: intl.formatMessage({
      description: 'Exhibitors V2 Filters searchBar',
      defaultMessage: 'Search by name',
    }),
    yearEdition: intl.formatMessage({
      description: 'Exhibitors V2 Filters yearEdition',
      defaultMessage: 'Edition',
    }),
    alphabet: intl.formatMessage({
      description: 'Exhibitors V2 Filters alphabet',
      defaultMessage: 'Search by initial letter',
    }),
    hall: intl.formatMessage({
      description: 'Exhibitors V2 Filters hall',
      defaultMessage: 'Pavilion where the stand is located',
    }),
    applyFilters: intl.formatMessage({
      description: 'Exhibitors V2 Filters applyFilters',
      defaultMessage: 'Apply filters',
    }),
    filter: intl.formatMessage({
      description: 'Exhibitors V2 Filters filter',
      defaultMessage: 'Filter',
    }),
    greyBox: {
      title: intl.formatMessage({
        description: 'Exhibitors V2 Filters greyBox title',
        defaultMessage: 'Your exhibitors 2025',
      }),
      body: intl.formatMessage({
        description: 'Exhibitors V2 Filters greyBox body',
        defaultMessage:
          'In this section you can review the brands you have listed as “to visit” and that you have “visited” and the folders you have created to organize your visit. The list remains available until December 2025.',
      }),
      link: intl.formatMessage({
        description: 'Exhibitors V2 Filters greyBox link',
        defaultMessage: 'Go to your list',
      }),
      notLoggedBody: intl.formatMessage({
        description: 'Exhibitors V2 Filters greyBox notLoggedBody',
        defaultMessage:
          'To add an exhibitor to your list of stands still to be visited,',
      }),
      notLoggedRegister: intl.formatMessage({
        description: 'Exhibitors V2 Filters greyBox notLoggedRegister',
        defaultMessage: 'register on the site',
      }),
      notLoggedLogin: intl.formatMessage({
        description: 'Exhibitors V2 Filters greyBox notLoggedLogin',
        defaultMessage: 'log in',
      }),
      or: intl.formatMessage({
        description: 'Exhibitors V2 Filters greyBox or',
        defaultMessage: 'or',
      }),
    },
    showResultsBtn: intl.formatMessage({
      description: 'Exhibitors V2 Filters showResultsBtn',
      defaultMessage: 'Display results',
    }),
  },
  PersonalPage: {
    title: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage title',
      defaultMessage: 'The exhibitors you still want to visit',
    }),
    subtitle: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage subtitle',
      defaultMessage:
        'In this section you will find all the exhibitors you have selected as those you still want “to visit”',
    }),
    exitEditMode: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage exitEditMode',
      defaultMessage: 'Exit from edit mode',
    }),
    backBtn: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage backBtn',
      defaultMessage: 'Back to the complete list',
    }),
    viewFolders: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage viewFolders',
      defaultMessage: 'View folders',
    }),
    folders: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage Folders',
      defaultMessage: 'Folders',
    }),
    createNewFolder: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage createNewFolder',
      defaultMessage: 'Create new folder',
    }),
    backAllFolders: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage backAllFolders',
      defaultMessage: 'Back to all the folders',
    }),
    folder: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage folder',
      defaultMessage: 'Folder',
    }),
    editName: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage editName',
      defaultMessage: 'Edit name',
    }),
    deleteFolder: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage deleteFolder',
      defaultMessage: 'Delete folder',
    }),
    folderCard: {
      listTitle1: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage listTitle1',
        defaultMessage: "You've created ",
      }),
      listTitle2sing: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage listTitle2sing',
        defaultMessage: ' folder',
      }),
      listTitle2plur: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage listTitle2plur',
        defaultMessage: ' folders',
      }),
      exhibitor: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage exhibitor',
        defaultMessage: 'exhibitor',
      }),
      exhibitors: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage exhibitors',
        defaultMessage: 'exhibitors',
      }),
    },
    emptyFoldersTitle: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage emptyFoldersTitle',
      defaultMessage:
        'Here you can organize the exhibitors you want to visit into folders.',
    }),
    manageExhibitors: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage manageExhibitors',
      defaultMessage: 'Organize exhibitors',
    }),
    moveExhibitor: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage moveExhibitor',
      defaultMessage: 'Move',
    }),
    removeExhibitor: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage removeExhibitor',
      defaultMessage: 'Delete',
    }),
    backTxt: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage backTxt',
      defaultMessage: 'Add exhibitors to your list',
    }),
    goToMap: intl.formatMessage({
      description: 'Exhibitors V2 PersonalPage goToMap',
      defaultMessage: 'Guarda i tuoi espositori sulla mappa',
    }),
    exhibitorDetail: {
      backToExhibitorList: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage backToExhibitorList',
        defaultMessage: 'See all the exhibitors ',
      }),
      contactButton: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage contactButton',
        defaultMessage: 'Contact',
      }),
      bookAppointmentButton: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage bookAppointmentButton',
        defaultMessage: 'Book an appointment',
      }),
      book: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage book',
        defaultMessage: 'Book',
      }),
      visitBrandPage: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage visitBrandPage',
        defaultMessage: 'Visit the brand page',
      }),
      findMore: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage findMore',
        defaultMessage: 'Find out more about our company and our history',
      }),
    },
    alerts: {
      exhibitor: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage alerts exhibitor',
        defaultMessage: 'exhibitor',
      }),
      exhibitors: intl.formatMessage({
        description: 'Exhibitors V2 PersonalPage alerts exhibitors',
        defaultMessage: 'exhibitors',
      }),
      edit: {
        plur: intl.formatMessage({
          description: 'Exhibitors V2 PersonalPage alerts edit plur',
          defaultMessage: 'have been moved to the folder',
        }),
        sing: intl.formatMessage({
          description: 'Exhibitors V2 PersonalPage alerts edit sing',
          defaultMessage: 'has been moved to the folder',
        }),
      },
      remove: {
        plur: intl.formatMessage({
          description: 'Exhibitors V2 PersonalPage alerts remove plur',
          defaultMessage: 'have been deleted from the folder',
        }),
        sing: intl.formatMessage({
          description: 'Exhibitors V2 PersonalPage alerts remove sing',
          defaultMessage: 'has been deleted from the folder',
        }),
      },
      delete: {
        plur: intl.formatMessage({
          description: 'Exhibitors V2 PersonalPage alerts delete plur',
          defaultMessage: 'have been deleted from the list',
        }),
        sing: intl.formatMessage({
          description: 'Exhibitors V2 PersonalPage alerts delete sing',
          defaultMessage: 'has been deleted from the list',
        }),
      },
    },
  },
  Common: {
    toVisit: intl.formatMessage({
      description: 'Exhibitors V2 Common tovisit',
      defaultMessage: 'To be visited',
    }),
    addToList: intl.formatMessage({
      description: 'Exhibitors V2 Common addToList',
      defaultMessage: 'Added to list',
    }),
    visited: intl.formatMessage({
      description: 'Exhibitors V2 Common visited',
      defaultMessage: 'Visited',
    }),
    markAsVisited: intl.formatMessage({
      description: 'Exhibitors V2 Common markAsVisited',
      defaultMessage: 'Mark as visited',
    }),
    markAsToVisit: intl.formatMessage({
      description: 'Exhibitors V2 Common markAsToVisit',
      defaultMessage: 'Mark as to visit',
    }),
    international: intl.formatMessage({
      description: 'Exhibitors V2 Common international',
      defaultMessage: 'international',
    }),
    design: intl.formatMessage({
      description: 'Exhibitors V2 Common design',
      defaultMessage: 'sustainable design',
    }),
    delete: intl.formatMessage({
      description: 'Exhibitors V2 Common delete',
      defaultMessage: 'Delete',
    }),
    edit: intl.formatMessage({
      description: 'Exhibitors V2 Common edit',
      defaultMessage: 'Edit',
    }),
    categories: intl.formatMessage({
      description: 'Exhibitors V2 Common categories',
      defaultMessage: 'Categories',
    }),
    products: intl.formatMessage({
      description: 'Exhibitors V2 Common products',
      defaultMessage: 'Products',
    }),
    map: intl.formatMessage({
      description: 'Exhibitors V2 Common map',
      defaultMessage: 'Map',
    }),
    tooltips: {
      map: intl.formatMessage({
        description: 'Exhibitors V2 Common tooltips map',
        defaultMessage: 'See on map',
      }),
      mail: intl.formatMessage({
        description: 'Exhibitors V2 Common tooltips mail',
        defaultMessage: 'Contact',
      }),
      calendar: intl.formatMessage({
        description: 'Exhibitors V2 Common tooltips calendar',
        defaultMessage: 'Book an appointment',
      }),
      calendarEmpty: intl.formatMessage({
        description: 'Exhibitors V2 Common tooltips calendarEmpty',
        defaultMessage:
          'At this time there are no slots available. Please contact the exhibitor to indicate a date and time that suits you',
      }),
      disableBook: intl.formatMessage({
        description: 'Exhibitors V2 Common tooltips disableBook',
        defaultMessage:
          'The exhibitor is not available for appointments at the stand',
      }),
    },
  },
  Register: {
    title: intl.formatMessage({
      description: 'Exhibitors V2 Register title',
      defaultMessage: 'This feature is for professional operators only',
    }),
    subtitle: intl.formatMessage({
      description: 'Exhibitors V2 Register subtitle',
      defaultMessage:
        'To add an exhibitor to your list of stands you still want to “visit”, log in or register on the site',
    }),
    subtitleCalendar: intl.formatMessage({
      description: 'Exhibitors V2 Register subtitleCalendar',
      defaultMessage:
        'To book an appointment, log in or register on the website',
    }),
    titleVisit: intl.formatMessage({
      description: 'Exhibitors V2 Register titleVisit',
      defaultMessage: 'This feature is reserved for registered users',
    }),
    login: intl.formatMessage({
      description: 'Exhibitors V2 Register login',
      defaultMessage: 'Login',
    }),
    notAccount: intl.formatMessage({
      description: 'Exhibitors V2 Register notAccount',
      defaultMessage: 'Do not have an account?',
    }),
    registerNow: intl.formatMessage({
      description: 'Exhibitors V2 Register registerNow',
      defaultMessage: 'Register now',
    }),
  },
  Alert: {
    newFolder: {
      partOne: intl.formatMessage({
        description: 'Exhibitors V2 Alert newFolder partOne',
        defaultMessage: 'The folder called',
      }),
      partTwo: intl.formatMessage({
        description: 'Exhibitors V2 Alert newFolder partTwo',
        defaultMessage: 'has been successfully created',
      }),
    },
  },
  Book: {
    title: intl.formatMessage({
      description: 'Exhibitors V2 Book title',
      defaultMessage: 'Book an appointment with',
    }),
    mapTitle: intl.formatMessage({
      description: 'Exhibitors V2 Book mapTitle',
      defaultMessage: 'Interactive map',
    }),
  },
});
